import { render, staticRenderFns } from "./DescargaTB.vue?vue&type=template&id=c0a6b500&scoped=true"
import script from "./DescargaTB.vue?vue&type=script&lang=js"
export * from "./DescargaTB.vue?vue&type=script&lang=js"
import style0 from "./DescargaTB.vue?vue&type=style&index=0&id=c0a6b500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a6b500",
  null
  
)

export default component.exports